module.exports = __webpack_public_path__ + "61dc057728dfa7ad74827e602f34e8fa.gif";